// extracted by mini-css-extract-plugin
export default {"closeIcon":"styles_closeIcon__Li1Ej","ContentContainer":"styles_ContentContainer__Xmrg2"};